import React, { Component } from 'react';

import UnderlinedText from '../../UnderlinedText';

import { isTouchDevice } from 'utils/device';

import './index.css';

export default class Answer extends Component {
	render() {
		const { index, idx, text, answers, textColor, handleSelect, onAnimationEnd, selected, transition } = this.props;
		const children = text.split(/\n/g);

		return (
			<div className={`answer animated animate-line ${selected ? 'selected' : ''} answer-${idx} ${!isTouchDevice() ? 'no-touch' : ''}`}
				onClick={() => { handleSelect(answers[idx].index + 1); }}
				onAnimationEnd={idx === answers.length - 1 && transition === 'out' ? onAnimationEnd.bind(this) : null}>
				<div className="checkbox">
					<img src={`./unchecked.png`} className="unchecked" alt="unchecked" />
					<img src={`./checked.png`} className="checked" alt="checked" />
					<img src={`./checked.png`} className="colour-checked" alt="checked" />
					<img src={`./unchecked-highlighted.png`} className="colour-unchecked" alt="unchecked" />
				</div>
				<div className="copy-container">
					{children.map((line, i) =>
						<UnderlinedText className={`copy ${transition}`} key={`answer-${i}`} text={line} colour={'#00ffff'} />)}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Quiz/Answer/index.js